import type { MoveResult, Movement } from '../movement/Movement';
import type { HexClickEvent } from '../render/Renderer';

export type HexClickHandler = (coord: HexClickEvent) => MoveResult;

/**
 * Build a click handler that forwards renderer-emitted axial coords to
 * `Movement.tryMove`. `onResolved` runs after every click (moved or blocked)
 * so callers can drive vision refresh, sounds, etc. from one seam.
 */
export function makeClickToMove(
  movement: Movement,
  onResolved?: (result: MoveResult, coord: HexClickEvent) => void,
): HexClickHandler {
  return (coord) => {
    const result = movement.tryMove(coord);
    onResolved?.(result, coord);
    return result;
  };
}
